import { axiosInstance } from ".."

const customOrderList = async (querry) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`/internal/CustomOrder?${querry}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default customOrderList;